import React from 'react';
import Tippy from '@tippyjs/react';
import * as Icon from 'react-feather';

const Label = (props) => {
  return (
    <label htmlFor={props.htmlFor} className={props.className}>
      {props.textContent}
      <Tippy content={props.toolTip} interactive>
        <span className="icon">
          <Icon.Info className="feather" />
        </span>
      </Tippy>
      {props.children}
    </label>
  );
};

export default Label;
